import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubTab from './../SubTab/SubTab';

const EnergyGrowthSupport = () => {
  const category = 'EnergyGrowthSupport';
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();

  const handleSelect = (num) => {
    if (select === num) setSelect(0);
    else setSelect(num);
  };

  const movePage = (path) => {
    navigate(path);
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}기업 지원 사업
            </div>
            <div className="banner_main_text">기업 지원 사업</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">기업지원사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>

            <div className="navi_box enterprise" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">에너지 동반성장 상생협력지원 사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  충남지역혁신프로젝트 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationCluster')}>
                  충남지역혁신클러스터
                </div>
                <div className="select_row" onClick={() => movePage('/business/carbonNeutralInfrastructure')}>
                  탄소중립실증인프라구축사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/EnergyGrowthSupport')}>
                  에너지 동반성장 상생혁력지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/LocalYouthJob')}>
                  충남 지역주도형 청년일자리지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthJobIncentive')}>
                  청년일자리 도약장려금지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/SMECenterSupport')}>
                  중소기업지원센터지원 사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/DormLeaseSupport')}>
                  산업단지 기숙사 임차지원 사업
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area temporary">
          <SubTab category={category} />

          {/* 🔹 공통 카드 헤더 (ChungnamInnovationProject와 동일 구조) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Energy Growth Support Program</p>
              <h2 className="business-hero-title">에너지 동반성장 상생협력 지원사업</h2>
              <p className="business-hero-period">사업기간 : 2026. 1. 1.(협약일) ~ 2026. 12. 31.</p>
            </div>
          </div>

          <div className="sub_main_back">
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>

              {/* ✅ 이미지 영역: 클래스명만 바꿔서 쓰면 됨 */}
              <div className="project_img_box">
                <div className="energy-growth-support-img1"></div>
              </div>

              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업 추진체계</div>
              </div>

              <div className="energy-growth-support-img2"></div>

              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">최종 성과</div>
              </div>

              <div className="local_final_result_box">
                <div className="project-result-box">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th>기관</th>
                        <th>역할</th>
                        <th>세부내용</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>한국동서발전(주)</td>
                        <td>· 총괄 및 성과점검</td>
                        <td>
                          <ul className="project-result-list">
                            <li>· 사업 총괄 및 성과관리 체계 구축</li>
                            <li>· 기업 지원 과제의 운영 및 성과 점검</li>
                            <li>· 사업비 확보 및 예산 운영</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td>당진시</td>
                        <td>· 총괄 및 성과점검</td>
                        <td>
                          <ul className="project-result-list">
                            <li>· 사업 홍보 및 행정 지원</li>
                            <li>· 기업 지원 과제 운영 및 성과관리 체계 구축</li>
                            <li>· 사업비 확보 및 정책적 지원</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td>운영위원회</td>
                        <td>· 사업 승인 및 주요 의사결정</td>
                        <td>
                          <ul className="project-result-list">
                            <li>· 사업 승인 및 주요 의사결정 기구 운영</li>
                            <li>· 사업 세부내용 승인 및 조정</li>
                            <li>· 주요 안건 논의 및 추진 방향 결정</li>
                          </ul>
                        </td>
                      </tr>

                      <tr>
                        <td>(사)충남산학융합원</td>
                        <td>· 사업 운영</td>
                        <td>
                          <ul className="project-result-list">
                            <li>· 사업 운영 및 성과관리</li>
                            <li>· 사업계획 수립 및 기업 지원 프로그램 운영</li>
                            <li>· 기업 참여 컨설팅 및 실무 지원</li>
                            <li>· 기업 성장 지원 및 성과 모니터링</li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnergyGrowthSupport;
